import { getLocaleWordContent } from '@/utils/language.util';
import React from 'react';

export default function Box({ num, it, qty, atc, setMess, ProductActions, ModalActions }) {
    // const i = 1;

    // const reduQty = (e, number, i) => {
    //     if (e) e.preventDefault();
    //     if (atc !== number) {
    //         setAtc(number);
    //         setQty(i - 1);
    //     } else setQty(qty - 1);
    // };
    // const increQty = (e, number) => {
    //     if (e) e.preventDefault();
    //     if (atc !== number) {
    //         setAtc(number);
    //         setQty(i + 1);
    //     } else setQty(qty + 1);
    // };

    // const checkOrder = (e, number, at) => {
    //     if (e) e.preventDefault();
    //     setAtc(number);
    //     console.log(at);
    //     setAt(at === '1' ? '0' : '1');
    //     const params = { p_no: number, activate: at };

    //     ProductActions.postOrder(params).then((rsp) => {
    //         if (rsp === 1) {
    //             alert('ok');
    //         } else {
    //             alert(rsp.msg);
    //         }
    //     });
    // };

    const sendBuy = (e, num) => {
        if (e) e.preventDefault();
        const params = { p_no: num, amount: qty };
        ProductActions.postBuy(params).then((rsp) => {
            if (rsp === 1) {
                ModalActions.showMessage({ show: true });
                setMess(getLocaleWordContent('구매예약 완료입니다'));
            } else {
                alert(rsp.msg);
            }
        });
    };

    const CheckBuy = (e, num) => {
        if (e) e.preventDefault();
        if (atc === 0) {
            sendBuy(e, num);
        } else {
            ModalActions.showMessage({ show: true });
            setMess(getLocaleWordContent('잔액이 부족합니다'));
        }
    };

    return (
        <div className="box">
            <div className="tit d_flex">
                <p className={num === 1 ? 'blue' : num === 2 ? 'green' : 'pur'}>{getLocaleWordContent(it.name)}</p>
                <p className="black">
                    [{it.period} Day] {it.price_min}~{it.price_max}
                </p>
            </div>
            <div className="sp10"></div>
            <div className="banner">
                <img src={require(`../../../resources/assets/images/${it.img}`)} alt="banner" />
            </div>

            {/* <div className="tit d_flex">
                <p className="black">구매 수량</p>

                <div className="d_flex">
                    <div className="calc d_flex">
                        <button onClick={(e) => reduQty(e, num)}>-</button>
                        <input
                            type="number"
                            value={atc === num && qty > 0 ? qty : 1}
                            onChange={(e) => changeQty(e)}
                            name="qty"
                        />
                        <button onClick={(e) => increQty(e, num)}>+</button>
                    </div>
                    <p className="black">개</p>
                </div>
            </div> */}
            <div className="bottom-btn">
                <button
                    className={it.activate === 0 ? 'b_blue btn01' : 'b_red btn02'}
                    onClick={(e) => CheckBuy(e, num)}
                >
                   {getLocaleWordContent('구매예약')}
                </button>
            </div>
        </div>
    );
}
